export default __webpack_public_path__ + "static/media/hearts-emoji.cc707854.svg";